import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMoreTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMoreTooltip: {
		id: 'issue-field-goals-readview-full.goals.show-more-tooltip',
		defaultMessage: 'See more selected goals',
		description: 'Label for trigger button to open a dialog with a list of selected goals',
	},
});
export default messages;
